import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles(({ breakpoints }: Theme) => createStyles({
  backToLis: {
    fontSize: 14,
    marginTop: 8,
    display: 'flex',
    '&:hover': {
      textDecoration: 'none',
    },
    [breakpoints.down('xs')]: {
      marginTop: 6,
    },
  },
  iconWrapper: {
    display: 'flex',
  },
  icon: {
    fontSize: '14px',
    height: '100%',
    marginRight: '4px',
  },
}), { name: 'ViewFrame' });

export default useStyles;
